import { Controller } from 'stimulus'
import Cookies from 'js-cookie'
export default class extends Controller {
  static targets = [ 'sidebar', 'header', 'headerButtons',  'themeSwitch']

  connect() {
    this.activeClass = 'active'
    this.overflowClass = 'overflow-hidden'
  }

  openSidebar(e) {
    this.sidebarTarget.sidebar.open(e)
  }

  openModal(e) {
    const data = e.currentTarget.dataset
    const el = document.getElementById(data.target)
    if (el) { el.modal.open(e, data.param) }
  }

  scrollTo(e) {
    e.preventDefault()
    const href = e.currentTarget.getAttribute('href')
    const target = document.querySelector(href)

    if (target) {
      let headerHeight = this.headerTarget.offsetHeight
      if (window.innerWidth < 768) {
        headerHeight -= this.headerButtonsTarget.offsetHeight
      }
      window.scroll(0, target.offsetTop - headerHeight)
    }
  }

  lock() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    document.body.style.paddingRight = `${scrollbarWidth}px`
    document.body.classList.add(this.overflowClass)

    if (this.headerTarget.classList.contains('fixed')) {
      this.headerTarget.style.right = `${scrollbarWidth}px`
    }
  }

  unlock() {
    document.body.style.paddingRight = null;
    document.body.classList.remove(this.overflowClass);
    if (this.headerTarget.classList.contains('fixed')) {
      this.headerTarget.style.removeProperty('right')
    }
  }

  calltouch(e) {
    e.preventDefault();
    try {
      window.Calltouch.Callback.onClickCallButton();
    } catch(e) {
      console.log('calltouch not working');
    }
  }
}
